// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StreamHidden__wrapper__3Dtgz","text":"StreamHidden__text__16vTp"};